export const PDF_PREVIEW_LOAD_ERROR = 'PDF konnte nicht geladen werden.';

/** Cookie-auth only for same-origin / relative API URLs. Cross-origin (OMD) stays omit. */
export function pdfFetchCredentials(url: string, pageOrigin?: string): RequestCredentials {
  const trimmed = String(url || '').trim();
  if (!trimmed) return 'omit';
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return 'omit';
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return 'include';
  const origin = pageOrigin || (typeof window !== 'undefined' ? window.location.origin : '');
  if (!origin) return 'include';
  try {
    const parsed = new URL(trimmed, origin);
    return parsed.origin === origin ? 'include' : 'omit';
  } catch {
    return 'omit';
  }
}

export async function fetchPdfBytes(
  url: string,
  fetchFn: typeof fetch = fetch,
  pageOrigin?: string,
): Promise<Uint8Array> {
  const res = await fetchFn(url, {
    credentials: pdfFetchCredentials(url, pageOrigin),
  });
  if (!res.ok) throw new Error(PDF_PREVIEW_LOAD_ERROR);
  const buf = await res.arrayBuffer();
  if (buf.byteLength < 5) throw new Error(PDF_PREVIEW_LOAD_ERROR);
  return new Uint8Array(buf);
}
